import React from "react";
import Formdata from "../ParentDashboard/index";

const index = () => {
  return (
    <div>
      <Formdata />
    </div>
  );
};

export default index;
